module.exports = __webpack_public_path__ + "static/font-43a3486b31404c3a6187360c9351b293.woff2";